import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { MessageService } from 'primeng/api';
import { GlobalServicesService } from './global-services.service';
@Injectable({
  providedIn: 'root',
})
export class RoleServicesService {
  host_api_url = environment.HOST.HOST_API_URL;
  fast_api_url = environment.HOST.FAST_API_URL;

  constructor(private http: HttpClient, public globalService: GlobalServicesService,
  ) { }
  // fast APIs
  getJobRolesFastApi(
    page = 1,
    size = 10,
    orderBy = 'desc',
    sortBy = 'id',
    searchTerm = '',
    filter = 'all'
  ): Observable<HttpResponse<any>> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('order_by', orderBy)
      .set('sort_by', sortBy);
  
    if (searchTerm) {
      params = params.set('search', searchTerm);
    }
    if (typeof filter !== 'string' && typeof filter === 'number') {
      params = params.set('role_type_id', filter);
    }
  
    return this.http.get<HttpResponse<any>>(`${this.fast_api_url}/job-roles`, {
      params,
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  
  createJobRolesFastApi(payload: any): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(`${this.fast_api_url}/job-roles`, payload, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  updateJobRolesFastApi(id: string, payload: any): Observable<HttpResponse<any>> {
    return this.http.put<HttpResponse<any>>(`${this.fast_api_url}/job-roles/${id}`, payload, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  deleteJobRolesFastApi(id: string): Observable<HttpResponse<any>> {
    return this.http.delete<HttpResponse<any>>(`${this.fast_api_url}/job-roles/${id}`, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  getSpecificJobRolesFastApi(id: string): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(`${this.fast_api_url}/job-roles/${id}`, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  getJobRolesFormDataFastApi(): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(`${this.fast_api_url}/job-roles/form-data`, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  getRoleAndPermissionFastApi(): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(`${this.fast_api_url}/roles`, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  getSpecificRoleAndPermissionFastApi(id: string): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(`${this.fast_api_url}/roles/${id}`, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  getRoleAndPermissionFormDataFastApi(): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(`${this.fast_api_url}/roles/form-data`, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  createRoleAndPermissionFastApi(payload: any): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(`${this.fast_api_url}/roles`, payload, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  updateRoleAndPermissionFastApi(id: string, payload: any): Observable<HttpResponse<any>> {
    return this.http.put<HttpResponse<any>>(`${this.fast_api_url}/roles/${id}`, payload, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  deleteRoleAndPermissionFastApi(id: string): Observable<HttpResponse<any>> {
    return this.http.delete<HttpResponse<any>>(`${this.fast_api_url}/roles/${id}`, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
}